import React from "react";
import { Link } from "react-router-dom";
import { Building2, CheckCircle } from "lucide-react";

const OnboardSubmittedPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="h-8 w-8 text-green-600" />
        </div>
        <div className="flex items-center justify-center mb-4 text-[#0076b5]">
          <Building2 className="h-6 w-6 mr-2" />
          <span className="font-semibold">VPD Employer Portal</span>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-3">
          Application submitted
        </h1>
        <p className="text-gray-600 mb-6">
          We are reviewing your business details and documents. You will receive
          an email with a link to set your password once your application is
          approved.
        </p>
        <Link
          to="/login"
          className="inline-flex justify-center w-full py-3 px-4 rounded-lg text-sm font-medium text-white"
          style={{ backgroundColor: "#0076b5" }}
        >
          Back to login
        </Link>
      </div>
    </div>
  );
};

export default OnboardSubmittedPage;
